import './App.css';
import './Medium.css';
import './Small.css'
import './Mobile.css'
import './SmallMobile.css'
import {Navigate, Route, Routes} from "react-router-dom";
import Home from "./components/Home";
import ErrorBoundary from "./components/ErrorBoundary";
import Error from "./components/Error";
import Feedback from "./components/Feedback";
import SignUp from "./components/SignUp";
import LogIn from "./components/LogIn";
import UserAccount from "./components/UserAccount";
import ResetPassword from "./components/ResetPassword";
import ForgotPassword from "./components/ForgotPassword";
import UploadSingle from "./components/UploadSingle";
import UploadBatch from "./components/UploadBatch";
import Submissions from "./components/Submissions";
import Submission from "./components/Submission";
import ExportCenter from "./components/ExportCenter";
import ScoreHistory from "./components/ScoreHistory";
import NetworkViewOld from "./components/NetworkViewOld";
import SimilarWorks from "./components/SimilarWorks";
import SuggestedEditorialAction from "./components/SuggestedEditorialAction";
import ImpactVsField from "./components/ImpactVsField";
import DashboardSettings from "./components/DashboardSettings";
import Faq from "./components/Faq";
import NetworkGraph from "./components/NetworkGraph";
import AboutUs from "./components/AboutUs";

function App() {
    return (
        <ErrorBoundary>
            <Routes>
                <Route path={"/"} element={<Home/>}/>
                <Route path={"/upload-single/*"} element={<UploadSingle/>}/>
                <Route path={"/upload-batch/*"} element={<UploadBatch/>}/>
                <Route path={"/submissions/*"} element={<Submissions/>}/>
                <Route path={"/submission/*"} element={<Submission/>}/>
                <Route path={"/export-center/*"} element={<ExportCenter/>}/>
                <Route path={"/score-history/*"} element={<ScoreHistory/>}/>
                <Route path={"/network/*"} element={<NetworkGraph/>}/>
                <Route path={"/similar-works/*"} element={<SimilarWorks/>}/>
                <Route path={"/suggested-editorial-action/*"} element={<SuggestedEditorialAction/>}/>
                <Route path={"/impact-vs-field/*"} element={<ImpactVsField/>}/>
                <Route path={"/faq/*"} element={<Faq/>}/>
                <Route path={"/account/*"} element={<UserAccount/>}/>
                <Route path={"/login/*"} element={<LogIn/>}></Route>
                <Route path={"/signup/*"} element={<SignUp/>}></Route>
                <Route path={"/forgot-password/*"} element={<ForgotPassword/>}></Route>
                <Route path={"/reset-password/*"} element={<ResetPassword/>}></Route>
                <Route path={"/error/*"} element={<Error/>}></Route>
                <Route path={"/feedback/*"} element={<Feedback/>}/>
                <Route path={"/dashboard-settings/*"} element={<DashboardSettings/>}/>
                <Route path={"/about/*"} element={<AboutUs/>}/>
                <Route path={'*'} element={<Navigate to="/"/>}/>
                {/*<Route path={"/terms/*"} element={<Terms/>}></Route>*/}
                {/*<Route path={"/privacy/*"} element={<Privacy/>}></Route>*/}
                {/*<Route path={"/admin/*"} element={<Admin/>}/>\*/}
                {/*<Route path={"/admin/user/*"} element={<AdminUser/>}/>\*/}
            </Routes>
        </ErrorBoundary>
    );
}

export default App;
